import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: () => import('../views/index/index.vue')
  },
  {
    path: '/hm',
    name: 'HealthMonitoring',
    component: () => import('../views/HealthMonitoring/HealthMonitoring.vue')
  },
  {
    path: '/eh',
    name: 'ElderlyHome',
    component: () => import('../views/elderlyHome/elderlyHome.vue')
  },
  {
    path: '/hm_transform',
    name: 'HealthMonitoring_transform',
    component: () => import('../views/HealthMonitoring/HealthMonitoring_transform.vue')
  },
  {
    path: '/hm_1',
    name: 'HealthMonitoring_1',
    component: () => import('../views/HealthMonitoring/HealthMonitoring_1.vue')
  },
  {
    path: '/monitor',
    name: 'Monitor',
    component: () => import('../views/monitor/monitor.vue')
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: () => import('../views/schedule/schedule.vue')
  },
  {
    path: '/hm_hotel',
    name: 'HealthMonitoring_hotel',
    component: () => import('../views/HealthMonitoring/HealthMonitoring_hotel.vue')
  },
  {
    path: '/hm_home',
    name: 'HealthMonitoring_home',
    component: () => import('../views/HealthMonitoring/HealthMonitoring_home.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
